import type { SetValueConfig } from "react-hook-form"
import { useFormContext } from "react-hook-form"

import type { PurchaseOrderForm } from "@/screens/Procurement/PurchaseOrder/types"

const usePurchaseOrderForm = (): {
  methods: ReturnType<typeof useFormContext<PurchaseOrderForm>>
  formValues: PurchaseOrderForm
  getField: <K extends keyof PurchaseOrderForm>(field: K) => PurchaseOrderForm[K]
  setField: (name: keyof PurchaseOrderForm, value: any, options?: SetValueConfig) => void
} => {
  const methods = useFormContext<PurchaseOrderForm>()

  const formValues = methods.getValues()

  const getField = function <K extends keyof PurchaseOrderForm>(field: K): PurchaseOrderForm[K] {
    return (methods as any).watch(field)
  }

  const setField = function (name: keyof PurchaseOrderForm, value: any, options?: SetValueConfig) {
    methods.setValue(name, value, options)
  }

  return {
    methods,
    formValues,
    getField,
    setField,
  }
}

export default usePurchaseOrderForm
